
import { Base } from '../base-component';

import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';

import './comparison.component.scss';

import * as $ from 'jquery';
import * as _ from 'lodash';

export class Comparison extends Base {

	variableName: string;
	imagePath: string;
	productKey: string;
	comparison: any[];
	benefitToggle: JQuery<HTMLElement>;
	comparisonChip: JQuery<HTMLElement>;
	productJson: any[];
	comparisonJson: any[] = [];
	pricingJson: any;
	switcherIndex: any;
	producttype: string;

	constructor(element: Element,
		analyticsService: AnalyticsService) {

		super(element);

	}

	init() {

		let storage: any = localStorage.getItem('comparison');
		this.variableName = this.element.getAttribute('data-variablename');
		this.imagePath = this.element.getAttribute('data-imagepath');
		this.productKey = this.element.getAttribute('data-productkey');
		this.producttype = this.element.getAttribute('data-producttype');
		this.comparisonJson = [];
		this.switcherIndex = {};

		if (this.producttype) {
			this.producttype = this.producttype.toLowerCase();
		}

		if (!storage) {

			storage = {};
			storage[this.productKey] = [];

			localStorage.setItem('comparison', JSON.stringify(storage));

		} else {

			storage = JSON.parse(storage);

			if (!storage[this.productKey]) {

				storage[this.productKey] = [];
				localStorage.setItem('comparison', JSON.stringify(storage));

			}

		}

		this.comparison = storage;

		this.benefitToggle = $('.js-toggle-benefits');
		this.comparisonChip = $('.comparison__compare-chip');

		this.getProducts();
		this.normalizeHeight();

		this.addCompareCheckDiv();
	}

	bindEvents() {

		$('.js-remove-all').click(() => {

			$('.comparison__slot').css('order', 99);

			this.resetSlots();
			this.resetMobile();

			$('.comparison').removeClass('comparison--comparing');
			$(`.form__control--checkbox input`).removeAttr('disabled');
			$(`.form__control--checkbox input`).prop('checked', false);

			this.element.getElementsByClassName('comparison__check--details')[0].classList.add('comparison__check--details--hide');

			this.comparison[this.productKey] = [];

			localStorage.setItem('comparison', JSON.stringify(this.comparison));

		})

		$(document).on('click', '.js-toggle-benefits', (e) => {

			$('.comparison__product__benefits__accordion').toggleClass('comparison__product__benefits__accordion--open');
			$('.comparison__product__benefits').toggleClass('comparison__product__benefits--open');

		});

		$(document).on('click', '.comparison__mobile__accordion', (e) => {

			if ($(e.currentTarget).hasClass('comparison__mobile__accordion--open')) {

				$(e.currentTarget).toggleClass('comparison__mobile__accordion--open');

			} else {

				$('.comparison__mobile__accordion').removeClass('comparison__mobile__accordion--open');
				setTimeout(function () {
					$(e.currentTarget)
						.toggleClass('comparison__mobile__accordion--open')
						.queue((next) => {
							$('html,body').animate({
								scrollTop: $(e.currentTarget).offset().top - 70
							},
								'slow');
							next();
						});
				}, 700);


			}

		});

		$(document).on('click', '.comparison__mobile__accordion__content', (e) => {
			e.stopImmediatePropagation();
			e.preventDefault();
		});

		$(document).on('click', '.comparison__mobile__graph-switcher__arrow--left', (e) => {
			let key = $(e.currentTarget).parent().data('key');

			if (this.switcherIndex[key] == 0) {
				this.switcherIndex[key] = this.pricingJson[key].length - 1;
			} else {
				this.switcherIndex[key]--;
			}

			let productTitle = this.pricingJson[key][this.switcherIndex[key]].productTitle;
			let productId = this.pricingJson[key][this.switcherIndex[key]].id;
			let productLink = this.pricingJson[key][this.switcherIndex[key]].productLink;
			let productButtons = this.pricingJson[key][this.switcherIndex[key]].buttons;

			$(`.comparison__mobile__graph-switcher__value[data-key='${key}']`)
				.text(productTitle);

			$(`.comparison__mobile__accordion[data-section='${key}'] .comparison__mobile__graph__bar__fill`)
				.removeClass('comparison__mobile__graph__bar__fill--active');

			$(`.comparison__mobile__accordion[data-section='${key}'] .comparison__mobile__graph-item[data-id='${productId}'] .comparison__mobile__graph__bar__fill`)
				.addClass('comparison__mobile__graph__bar__fill--active');

			let productButtonsHtml = "";

			let btnCount = 0;

			productButtons.forEach(btn => {

				btnCount++;

				productButtonsHtml += this.renderButtons(btn, productButtons.length == btnCount, productButtons, btnCount);

			});

			$(`.comparison__mobile__accordion[data-section='${key}'] .comparison__mobile-graph-buttons`).html(productButtonsHtml);
			//comparison__mobile-graph-buttons

			//Analytics
			let $dtmtargetParentContainer = $(e.currentTarget).parents("div.comparison__mobile__accordion__content");
			if ($dtmtargetParentContainer.length) {
				$dtmtargetParentContainer.attr("data-trackingregion", "compare " + this.producttype + " > " + productTitle);
				$dtmtargetParentContainer.find("a.js-apply-now-modal-open").eq(0).attr("data-text", productTitle + " | apply now button click").attr("data-id", "link_content_compare " + this.producttype);
				$dtmtargetParentContainer.find("a.comparison__mobile__graph__tell-me-more").eq(0).attr("data-text", productTitle + " | tell me more button click").attr("data-id", "link_content_compare " + this.producttype);
			}

		});

		$(document).on('click', '.comparison__mobile__graph-switcher__arrow--right', (e) => {
			let key = $(e.currentTarget).parent().data('key');

			if (this.switcherIndex[key] == this.pricingJson[key].length - 1) {
				this.switcherIndex[key] = 0;
			} else {
				this.switcherIndex[key]++;
			}

			let productTitle = this.pricingJson[key][this.switcherIndex[key]].productTitle;
			let productId = this.pricingJson[key][this.switcherIndex[key]].id;
			let productLink = this.pricingJson[key][this.switcherIndex[key]].productLink;
			let productButtons = this.pricingJson[key][this.switcherIndex[key]].buttons;

			$(`.comparison__mobile__graph-switcher__value[data-key='${key}']`)
				.text(productTitle);

			$(`.comparison__mobile__accordion[data-section='${key}'] .comparison__mobile__graph__bar__fill`)
				.removeClass('comparison__mobile__graph__bar__fill--active');

			$(`.comparison__mobile__accordion[data-section='${key}'] .comparison__mobile__graph-item[data-id='${productId}'] .comparison__mobile__graph__bar__fill`)
				.addClass('comparison__mobile__graph__bar__fill--active');

			let productButtonsHtml = "";

			let btnCount = 0;

			productButtons.forEach(btn => {

				btnCount++;

				productButtonsHtml += this.renderButtons(btn, productButtons.length == btnCount, productButtons, btnCount);

			});

			$(`.comparison__mobile__accordion[data-section='${key}'] .comparison__mobile-graph-buttons`).html(productButtonsHtml);

			//Analytics
			let $dtmtargetParentContainer = $(e.currentTarget).parents("div.comparison__mobile__accordion__content");
			if ($dtmtargetParentContainer.length) {
				$dtmtargetParentContainer.attr("data-trackingregion", "compare " + this.producttype + " > " + productTitle);
				$dtmtargetParentContainer.find("a.js-apply-now-modal-open").eq(0).attr("data-text", productTitle + " | apply now button click").attr("data-id", "link_content_compare " + this.producttype);
				$dtmtargetParentContainer.find("a.comparison__mobile__graph__tell-me-more").eq(0).attr("data-text", productTitle + " | tell me more button click").attr("data-id", "link_content_compare " + this.producttype);
			}

		});

		window.addEventListener('resize', this.debounce(() => {

			this.normalizeHeight();

		}, 50, false));

	}

	debounce(func, wait, immediate) {
		let timeout;
		return function () {
			let context = this, args = arguments;
			let later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	normalizeHeight() {

		let products = $('.comparison__product-wrapper');
		let minHeight = 0;

		if (products.length > 0) {

			products.each((idx, el) => {

				if ($(el).outerHeight() > minHeight) {
					minHeight = $(el).outerHeight();
				}

			});

			$('.comparison__placeholder--col').css('min-height', `${minHeight}px`);

		}

		let descriptions = $('.comparison__product__section[data-section="description"]');

		minHeight = 0; //reset

		if (descriptions.length > 0) {

			descriptions.each((idx, el) => {

				if ($(el).outerHeight() > minHeight) {
					minHeight = $(el).outerHeight();
				}

			});

			$('.comparison__product__section[data-section="description"]').css('min-height', `${minHeight}px`);

		}

		let applications = $('.comparison__product__section[data-section="apply"]');

		minHeight = 0; //reset

		if (applications.length > 0) {

			applications.each((idx, el) => {

				if ($(el).height() > minHeight) {
					minHeight = $(el).height();
				}

			});

			$('.comparison__product__section[data-section="apply"]').css('min-height', `${minHeight}px`);

		}

		let benefits = $('.comparison__product__benefits');

		minHeight = 0; //reset

		if (benefits.length > 0) {

			benefits.each((idx, el) => {

				if ($(el).outerHeight() > minHeight) {
					minHeight = $(el).outerHeight();
				}

			});

			$('.comparison__product__benefits').css('min-height', `${minHeight}px`);

		}

		let buttons = $('.comparison__product__section-buttons');

		minHeight = 0; //reset

		if (buttons.length > 0) {

			buttons.each((idx, el) => {

				if ($(el).height() > minHeight) {
					minHeight = $(el).height();
				}

			});

			$('.comparison__product__section-buttons').css('min-height', `${minHeight}px`);

		}
	}

	getProducts() {

		this.productJson = window[this.variableName];

		let comparisonMatch = false;

		this.productJson.forEach((product, idx, arr) => {

			this.renderComparisonChips(product);

			$('.js-compare').click((e) => this.compareClick(e));

			$('.form__control--checkbox').click((e) => this.compareCheckClick(e));

			if (this.comparison[this.productKey].find((item) => { return item == product.id })) {

				this.comparisonJson.push(product);

				let docfragment = document.createDocumentFragment();
				docfragment.appendChild(this.renderProduct(product));

				this.renderSlot(docfragment);

				$(`.comparison__compare-chip[data-id="${product.id}"]`).addClass('comparison__compare-chip--active');

				comparisonMatch = true;
			}

		});

		if (comparisonMatch) {

			this.renderMobile();

			if (!$('.comparison').hasClass('comparison--comparing')) {
				$('.comparison').addClass('comparison--comparing');
			}

			this.normalizeHeight();

		}

		if (this.comparison) {

			this.comparison[this.productKey].forEach(id => {

				$(`.form__control--checkbox[data-id='${id}'] input`).prop('checked', 'checked');

			});

			if (this.comparison[this.productKey].length >= 3) {

				$(`.form__control--checkbox input`).prop('disabled', 'disabled');

				this.comparison[this.productKey].forEach(id => {

					$(`.form__control--checkbox[data-id='${id}'] input`).removeAttr('disabled');

				});

			}

		}

	}

	addCompareCheckDiv() {
		var displayDiv = document.createElement("div");
		displayDiv.classList.add("col-12");
		displayDiv.classList.add("comparison__check");

		var display = `<span class="comparison__check--details comparison__check--details--hide">
		Only 3 items can be compared. Please deselect an item to select another item.
		</span>`;

		displayDiv.innerHTML = display;

		let divToAppendTo = this.element.getElementsByClassName('title title--page text-center');
		if (divToAppendTo.length == 0) {
			divToAppendTo = this.element.getElementsByClassName('title title--entrance');
		}
		if (divToAppendTo.length > 0) {
			divToAppendTo[0].parentNode.append(displayDiv);
		}
	}

	compareCheckClick(e) {

		var isDisabled = e.currentTarget.getElementsByClassName("js-compare")[0].disabled;

		if (isDisabled) {

			this.element.getElementsByClassName('comparison__check--details')[0].classList.remove('comparison__check--details--hide');

		} else {

			this.element.getElementsByClassName('comparison__check--details')[0].classList.add('comparison__check--details--hide');

		}
	}

	renderProduct(input) {

		let productPrices = "";
		let productTags = "";
		let benefitsAndFeatures = "";
		let productButtons = "";

		input.pricing.forEach(price => {
			productPrices += this.renderProductPrice(price);
		});

		input.tags.forEach(tag => {
			productTags += " " + tag.replace(/ /g, "-");
		});

		input.benefitsAndFeatures.forEach(ben => {
			benefitsAndFeatures += `<li>${ben}</li>`;
		});

		let btnCount = 0;

		input.buttons.forEach(btn => {

			btnCount++;

			productButtons += this.renderButtons(btn, input.buttons.length == btnCount, input, btnCount);

		});

		let output = "";
		output += `
			<div class="comparison__product-wrapper" data-id="${input.id}" data-trackingregion="compare ` + this.producttype + ` > ${input.title}">

				<div class="comparison__product__header">
					${input.title}
				</div>

				<div class="comparison__product__section" data-section="description">

					<span class="title title--notes">
						description
					</span>

					<p>
						${input.subTitle}
					</p>

				</div>

				${productPrices}

				<div class="comparison__product__section comparison__product__section--wide"  data-section="apply">
                    
                    <div class="comparison__product__section-buttons">
                    
                        ${productButtons}
                        
                    </div>

					<span class="title title--notes">
						${input.content}
					</span>

				</div>

				<div class="comparison__product__benefits">
					<span class="title title--notes">
						BENEFITS AND KEY FEATURES
					</span>
					<ul>
						${benefitsAndFeatures}
					</ul>
				</div>

			</div>

		`;

		return document.createRange().createContextualFragment(output);
	}

	renderButtons(input, last, product, index) {

		let output = "";

		//Analytics - add the 3rd param to hold product title to cover the below buttons interaction

		let productTitle = product.productTitle ? product.productTitle : product.title;

		if (input.isModal) {

			output += `
                <div class="comparison__product__button ${last ? 'comparison__product__button--last' : ''}">
                    <a class="button button--main js-apply-now-modal-open"
                        href="#"
                        target=""
                        data-modal="apply-now-modal-${input.modalId}"
                        data-id="link_content_compare `+ this.producttype + `"
                        data-text="`+ productTitle + ` | ${input.title} button click">

                        ${input.title}

                    </a>
                </div>
            `;

		} else {

			output += `
                <div class="comparison__product__button ${last ? 'comparison__product__button--last' : ''}">
                    <a class="button button--main ${index === 1 ? '' : 'button--white button--border-blue'} comparison__mobile__graph__tell-me-more"
                        href="${input.url}"
                        target="${input.target}"
                        data-id="link_content_compare `+ this.producttype + `"
                        data-text="`+ productTitle + ` | ${input.title} button click">

                        ${input.title}

                    </a>
                </div>
            `;

		}

		return output;

	}

	renderProductPrice(input) {
		let output = "";

		output += `<div class="comparison__product__section" data-section="price">`;

		output += `
			<div class="title title--notes">
				${input.subTitle}
			</div>
		`;

		if (input.symbol) {
			output += `
				<span class="title title--initial title--currency-med">
					${input.symbol}
				</span>
			`;
		}

		output += `
			<span class="title title--initial title--number-med">
				${input.title}
			</span>
		`;

		if (input.tooltip) {
			output += `
				<span title="some tooltip">
					<i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
						<path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path>
					</svg>
					</i>
				</span>
			`;
		}

		if (input.strike) {
			output += `
				<div class="title title--number-strike">
					<span class="title title--number-striker"></span>
			`;

			if (input.symbol) {
				output += `
					<span class="title title--initial title--currency-sml">
						${input.symbol}
					</span>
				`;
			}

			output += `
					<span class="title title--initial title--number-sml">
						${input.title}
					</span>
				</div>
			`;
		}

		output += `</div>`; //main close

		return output;
	}

	renderComparisonChips(item) {

		let output = "";
		output += `

			<label data-id="${item.id}" class="comparison__compare-checkbox form__control form__control--checkbox">

				${item.shortTitle}
				<input type="checkbox" data-id="${item.id}" class="js-compare">
				<div class="form__control-indicator"></div>

			</label>
		`;

		let docfragment = document.createDocumentFragment();
		docfragment.appendChild(document.createRange().createContextualFragment(output));
		document.querySelector('.comparison__compare-chip-wrapper').appendChild(docfragment);
	}

	compareClick(e) {

		e.stopImmediatePropagation();

		let id = $(e.currentTarget).data('id');

		if (this.comparison[this.productKey].find((item) => { return item == id })) {
			//remove the product from comparison
			let index = this.comparison[this.productKey].indexOf(id);
			if (index >= 0) {

				this.comparison[this.productKey].splice(index, 1);

				localStorage.setItem('comparison', JSON.stringify(this.comparison));

			}

			if (this.comparisonJson.find((item) => { return item.id == id })) {

				let index = _.findIndex(this.comparisonJson, (o) => {
					return o.id == id;
				});

				if (index >= 0) {

					this.comparisonJson.splice(index, 1);

					this.removeMobileProduct(id);
				}

			}

			if (this.comparison[this.productKey].length <= 1) {
				$('.comparison__mobile__graph-switcher__arrow').hide();
			} else {
				$('.comparison__mobile__graph-switcher__arrow').show();
			}

			if (this.comparison[this.productKey].length < 1) {

				$('.comparison').removeClass('comparison--comparing');
				$(`.comparison__compare-chip--active`).removeClass('comparison__compare-chip--active');
				this.resetSlots();
				this.resetMobile();

			} else {

				$(`.comparison__compare-chip--active[data-id='${id}']`).removeClass('comparison__compare-chip--active');

				//remove column and reorder placeholders
				$(`.comparison__product-wrapper[data-id="${id}"]`).parent().html(`
					<div class="comparison__placeholder comparison__placeholder--col">

						<svg viewBox='0 0 300 100' preserveAspectRatio='none'>
							<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>
						</svg>

						<span class="comparison__placeholder__icon">
							<i data-component="icon" data-icon="icon-hand" class="icon ">
								<svg xmlns="http://www.w3.org/2000/svg" width="32" height="34" viewBox="0 0 32 34">
									<path fill="#858D9D" fill-rule="evenodd" d="M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z"></path>
								</svg>
							</i>
						</span>

						<span class="comparison__placeholder__text">
							Use the tags to select a product to compare
						</span>

					</div>
				`);

				if ($('.comparison__product-wrapper').length >= 1) {

					this.normalizeHeight();

					$('.comparison__slot').css('order', 99);

					$('.comparison__product-wrapper').each((idx, item) => {
						$(item).parent().css('order', idx);
					});

				} else {
					$('.comparison__slot').css('order', 99);
					$('.comparison__slot').addClass('comparison__slot--hide')
						.delay(350)
						.queue(function (next) {

							$(this).removeClass('comparison__slot--active').removeClass('comparison__slot--hide');

							$('.comparison__placeholder--large')
								.removeClass('comparison__placeholder--hide')
								.removeClass('comparison__placeholder--hidden');

							next();
						});

				}

				$(`.form__control--checkbox input`).removeAttr('disabled');

			}

			this.normalizeHeight();

		} else {
			//product is not compared yet, check to see comparison limit has been met

			let product = this.productJson.find((item) => {
				return item.id == id;
			});

			if (!$('.comparison').hasClass('comparison--comparing')) {
				$('.comparison').addClass('comparison--comparing');
			}

			if (!this.comparison) {

				this.comparison = [];

				this.comparison[this.productKey].push(id);

				localStorage.setItem('comparison', JSON.stringify(this.comparison));

			} else if (this.comparison[this.productKey].length >= 3) {

				$(`.form__control--checkbox input`).prop('disabled', 'disabled');

				this.comparison[this.productKey].forEach(id => {

					$(`.form__control--checkbox[data-id='${id}'] input`).removeAttr('disabled');

				});

				e.preventDefault();

			} else if (this.comparison[this.productKey].length < 3) {

				this.comparisonJson.push(product);

				let docfragment = document.createDocumentFragment();
				docfragment.appendChild(this.renderProduct(product));

				this.renderSlot(docfragment);
				this.addMobileProduct(product);

				$('.comparison__slot').addClass('comparison__slot--active');

				this.comparison[this.productKey].push(id);
				localStorage.setItem('comparison', JSON.stringify(this.comparison));

				if (this.comparison[this.productKey].length >= 3) {

					$(`.form__control--checkbox input`).prop('disabled', 'disabled');

					this.comparison[this.productKey].forEach(id => {

						$(`.form__control--checkbox[data-id='${id}'] input`).removeAttr('disabled');

					});

				}

				this.normalizeHeight();

			}

			if (this.comparison[this.productKey].length <= 1) {
				$('.comparison__mobile__graph-switcher__arrow').hide();
			} else {
				$('.comparison__mobile__graph-switcher__arrow').show();
			}

		}

		// Analytics
		let analyticsFinalcompare = [];
		for (var idx = 0, len = this.comparisonJson.length; idx < len; idx++) {
			analyticsFinalcompare.push(this.comparisonJson[idx].title);
		}
		if (analyticsFinalcompare.length) {
			this.analyticsService.dtmGenericUserInteraction("cta_Compare " + this.producttype + "-" + analyticsFinalcompare.join(" > "));
		}

		this.normalizeHeight();

	}

	renderSlot(fragment) {

		$('.comparison__slot').each((idx, item) => {

			let hasProduct = $(item).find('.comparison__product-wrapper').length > 0;

			if (!hasProduct) {
				item.innerHTML = "";
				item.appendChild(fragment);
				return false;
			}

		});

		TooltipsService.initTooltips();

	}

	resetSlots() {
		$('.comparison__slot').css('order', 99);
		$('.comparison__slot').each((idx, el) => {
			if ($(el).data('slot') != 3) {
				$(el).html(`
					<div class="comparison__placeholder comparison__placeholder--col">

						<svg viewBox='0 0 300 100' preserveAspectRatio='none'>
							<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>
						</svg>

						<span class="comparison__placeholder__icon">
							<i data-component="icon" data-icon="icon-hand" class="icon ">
								<svg xmlns="http://www.w3.org/2000/svg" width="32" height="34" viewBox="0 0 32 34">
									<path fill="#858D9D" fill-rule="evenodd" d="M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z"></path>
								</svg>
							</i>
						</span>

						<span class="comparison__placeholder__text">
							Use the tags to select a product to compare
						</span>

					</div>
				`);
			} else {
				$(el).html(`
					<div class="comparison__placeholder comparison__placeholder--col">

						<svg viewBox='0 0 300 100' preserveAspectRatio='none'>
							<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>
						</svg>

						<span class="comparison__placeholder__icon">
							<i data-component="icon" data-icon="icon-hand" class="icon ">
								<svg xmlns="http://www.w3.org/2000/svg" width="32" height="34" viewBox="0 0 32 34">
									<path fill="#858D9D" fill-rule="evenodd" d="M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z"></path>
								</svg>
							</i>
						</span>

						<span class="comparison__placeholder__text">
							Use the tags to select a product to compare
						</span>

						<img class="comparison__placeholder__image responsive-image responsive-image--animation"
							src="${this.imagePath}"
							alt="place holder image" />

					</div>
				`);
			}
		});

	}

	resetMobile() {

		this.comparisonJson = [];
		this.pricingJson = [];

		$(".comparison__mobile__wrapper").html(`

			<div class="comparison__placeholder comparison__placeholder--col">

				<svg viewBox='0 0 300 100' preserveAspectRatio='none'>
					<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>
				</svg>

				<span class="comparison__placeholder__icon">
					<i data-component="icon" data-icon="icon-hand" class="icon ">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="34" viewBox="0 0 32 34">
							<path fill="#858D9D" fill-rule="evenodd" d="M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z"></path>
						</svg>
					</i>
				</span>

				<span class="comparison__placeholder__text">
					Use the tags to select a product to compare
				</span>

			</div>

		`);
	}

	parsePricing() {
		this.pricingJson = (_.groupBy(_.flatMap(this.comparisonJson.map((product) => {
			return product.pricing.map((price) => {
				price.id = product.id;
				price.productTitle = product.title;
				price.productShortTitle = product.shortTitle;
				price.productLink = product.productLink;
				price.buttons = product.buttons;
				return price;
			});
		})), 'subTitle'));

		_.mapKeys(this.pricingJson, (value, key) => {

			this.switcherIndex[key] = 0;

			let maxValue: number = _.max(
				_.map(this.pricingJson[key], (price: any) => {
					return parseInt(price.title);
				})
			);

			this.pricingJson[key].forEach(price => {

				price.percent = _.round(parseInt(price.title) / maxValue * 100, 0);

			});

		});
	}

	//mobile rendering
	renderMobile() {

		$(".comparison__mobile__wrapper").html('');

		this.parsePricing();

		let fragment = document.createDocumentFragment();
		let descriptions = "";
		let benefitsAndFeatures = "";
		let priceAccordions = "";

		this.comparisonJson.forEach((product, idx, arr) => {

			let benefits = "";
			let features = "";
			let productButtons = "";

			let btnCount = 0;

			product.buttons.forEach(btn => {

				btnCount++;

				productButtons += this.renderButtons(btn, product.buttons.length == btnCount, product, btnCount);

			});

			descriptions += `
			<div class="comparison__mobile__accordion__content__wrapper" data-id="${product.id}" data-trackingregion="compare ` + this.producttype + ` > ${product.title}">

					<div class="comparison__mobile__title">
						${product.title}
					</div>

					<p>
						${product.subTitle}
					</p>

					${productButtons}

				</div>
			`;

			product.benefitsAndFeatures.forEach(ben => {
				benefits += `<li>${ben}</li>`;
			});

			benefitsAndFeatures += `
				<div class="comparison__mobile__accordion__content__wrapper" data-id="${product.id}">

					<div class="comparison__mobile__title">
						${product.title}
					</div>

					<span class="title title--notes">
						BENEFITS AND KEY FEATURES
					</span>
					<ul>
						${benefits}
					</ul>

				</div>
			`;

		});

		_.mapKeys(this.pricingJson, (value, key: number) => {

			let graphs = "";

			this.pricingJson[key].sort((a, b) => {

				return parseInt(a.title) - parseInt(b.title);

			}).forEach((price, i) => {
				graphs += `

					<div class="comparison__mobile__graph-item" data-id="${price.id}">

						<div class="comparison__mobile__graph__title">
							${price.productShortTitle}
						</div>

						<span class="title title--initial title--currency-sml">
							${price.symbol}
						</span>

						<span class="title title--initial title--number-sml">

							${price.title}

						</span>

						<div class="comparison__mobile__graph__bar">

							<div class="comparison__mobile__graph__bar__fill ${i == 0 ? 'comparison__mobile__graph__bar__fill--active' : ''}" style="width: ${price.percent}%">

							</div>

						</div>

					</div>

				`;
			});

			let pricingButtons = "";

			let btnCount = 0;

			this.pricingJson[key][0].buttons.forEach(btn => {

				btnCount++;

				pricingButtons += this.renderButtons(btn, this.pricingJson[key][0].buttons.length == btnCount, value[0], btnCount);

			});

			priceAccordions += `
			<div class="comparison__mobile__accordion" data-section="${key}" data-id="link_accordion_accordion" data-text="compare ` + this.producttype + ` | ${key}" >

					<span class="comparison__mobile__accordion__heading">
						${key}
					</span>

					<span class="comparison__mobile__chevron">

						<i data-component="icon" data-icon="link-chevron" class="icon "><!--?xml version="1.0" encoding="UTF-8"?-->
							<svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g id="Dsk-/-arrow-/-blue" fill-rule="nonzero" fill="#0089FF">
									<polygon id="flechita" points="1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981"></polygon>
								</g>
								</g>
							</svg>
						</i>

					</span>

					<div class="comparison__mobile__accordion__content" data-trackingregion="compare `+ this.producttype + ` > ${value[0].productTitle}">

						<div class="comparison__mobile__graph-wrapper">

							<div class="comparison__mobile__graph-wrapper__inner">
								${graphs}
							</div>

							<div class="comparison__mobile__graph-switcher" data-key="${key}">
								<div class="comparison__mobile__graph-switcher__arrow comparison__mobile__graph-switcher__arrow--left">
									<i data-component="icon" data-icon="arrow-left-slider" class="icon ">
										<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18.57 33.23"><defs><style>.cls-1{fill:url(#linear-gradient);}</style><linearGradient id="linear-gradient" y1="16.61" x2="18.57" y2="16.61" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffb94f"/><stop offset="1" stop-color="#ff5a00"/></linearGradient></defs><title>arrow-left-2</title><polygon id="Fill-4" class="cls-1" points="16.61 33.23 18.57 31.27 3.92 16.61 18.57 1.96 16.61 0 0 16.61 16.61 33.23"/></svg>
									</i>
								</div>

								<span class="comparison__mobile__graph-switcher__value" data-key="${key}">${value[0].productTitle}</span>

								<div class="comparison__mobile__graph-switcher__arrow comparison__mobile__graph-switcher__arrow--right">
									<i data-component="icon" data-icon="arrow-right-slider" class="icon ">
										<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18.57 33.23"><defs><style>.cls-1{fill:url(#linear-gradient);}</style><linearGradient id="linear-gradient" y1="16.61" x2="18.57" y2="16.61" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffb94f"/><stop offset="1" stop-color="#ff5a00"/></linearGradient></defs><title>arrow-right-2</title><polygon id="Fill-4" class="cls-1" points="1.96 33.23 0 31.27 14.66 16.61 0 1.96 1.96 0 18.57 16.61 1.96 33.23"/></svg>
									</i>
								</div>
							</div>

                            <div class="comparison__mobile-graph-buttons">

                                ${pricingButtons}
                                
                            </div>

						</div>

					</div>

				</div>
			`;

		});

		let descriptionOutput = `
			<div class="comparison__mobile__accordion" data-section="description" data-id="link_accordion_accordion" data-text="compare `+ this.producttype + ` | description">

				<span class="comparison__mobile__accordion__heading">
					Description
				</span>

				<span class="comparison__mobile__chevron">

					<i data-component="icon" data-icon="link-chevron" class="icon "><!--?xml version="1.0" encoding="UTF-8"?-->
						<svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="Dsk-/-arrow-/-blue" fill-rule="nonzero" fill="#0089FF">
								<polygon id="flechita" points="1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981"></polygon>
							</g>
							</g>
						</svg>
					</i>

				</span>

				<div class="comparison__mobile__accordion__content">

					${descriptions}

				</div>

			</div>
		`;

		let benefitsAndFeaturesOutput = `
		<div class="comparison__mobile__accordion" data-section="benefits" data-id="link_accordion_accordion" data-text="compare `+ this.producttype + ` | benefits & key features">

				<span class="comparison__mobile__accordion__heading">
					BENEFITS & KEY FEATURES
				</span>

				<span class="comparison__mobile__chevron">

					<i data-component="icon" data-icon="link-chevron" class="icon "><!--?xml version="1.0" encoding="UTF-8"?-->
						<svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<g id="Dsk-/-arrow-/-blue" fill-rule="nonzero" fill="#0089FF">
								<polygon id="flechita" points="1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981"></polygon>
							</g>
							</g>
						</svg>
					</i>

				</span>

				<div class="comparison__mobile__accordion__content">

					${benefitsAndFeatures}

				</div>

			</div>
		`;

		fragment.appendChild(document.createRange().createContextualFragment(descriptionOutput));
		fragment.appendChild(document.createRange().createContextualFragment(priceAccordions));
		fragment.appendChild(document.createRange().createContextualFragment(benefitsAndFeaturesOutput));
		document.querySelector('.comparison__mobile__wrapper').appendChild(fragment);
	}

	addMobileProduct(product) {

		if (document.querySelectorAll('.comparison__mobile__accordion').length > 0) {

			this.parsePricing();

			_.mapKeys(this.pricingJson, (value, key: number) => {

				let graphs = "";

				this.pricingJson[key].sort((a, b) => {

					return parseInt(a.title) - parseInt(b.title);

				}).forEach((price, i) => {
					graphs += `

						<div class="comparison__mobile__graph-item" data-id="${price.id}">

							<div class="comparison__mobile__graph__title">
								${price.productShortTitle}
							</div>

							<span class="title title--initial title--currency-sml">
								${price.symbol}
							</span>

							<span class="title title--initial title--number-sml">

								${price.title}

							</span>

							<div class="comparison__mobile__graph__bar">

								<div class="comparison__mobile__graph__bar__fill ${i == 0 ? 'comparison__mobile__graph__bar__fill--active' : ''}" style="width: ${price.percent}%">

								</div>

							</div>

						</div>

					`;

				});

				$(`.comparison__mobile__accordion[data-section="${key}"] .comparison__mobile__graph-wrapper__inner`)
					.html(graphs);

			});

			let productButtons = "";

			let btnCount = 0;

			product.buttons.forEach(btn => {

				btnCount++;

				productButtons += this.renderButtons(btn, product.buttons.length == btnCount, product, btnCount);

			});

			let descriptionFragment = document.createDocumentFragment();
			descriptionFragment.appendChild(document.createRange().createContextualFragment(`
				<div class="comparison__mobile__accordion__content__wrapper" data-id="${product.id}">

					<div class="comparison__mobile__title">
						${product.title}
					</div>

					<p>
						${product.subTitle}
					</p>

					${productButtons}

				</div>
			`));

			document.querySelector('.comparison__mobile__accordion[data-section="description"] > .comparison__mobile__accordion__content')
				.appendChild(descriptionFragment);

			let priceAccordions = "";
			let benefits = "";
			let features = "";

			product.benefitsAndFeatures.forEach(ben => {
				benefits += `<li>${ben}</li>`;
			});

			let benefitFragment = document.createDocumentFragment();
			benefitFragment.appendChild(document.createRange().createContextualFragment(`
				<div class="comparison__mobile__accordion__content__wrapper" data-id="${product.id}">

					<div class="comparison__mobile__title">
						${product.title}
					</div>

					<span class="title title--notes">
						BENEFITS AND KEY FEATURES
					</span>
					<ul>
						${benefits}
					</ul>

				</div>
			`));

			document.querySelector('.comparison__mobile__accordion[data-section="benefits"] > .comparison__mobile__accordion__content')
				.appendChild(benefitFragment);

		} else {
			this.renderMobile();
		}

	}

	removeMobileProduct(id) {
		$(`.comparison__mobile__accordion__content__wrapper[data-id="${id}"]`).remove();
		$(`.comparison__mobile__graph-item[data-id="${id}"]`).remove();
	}

}



// WEBPACK FOOTER //
// ./components/comparison/comparison.component.ts